import { createApp } from "vue";
import App from "./App.vue";
import router from "@/router";
import { createPinia } from "pinia";
import "./styles/main.scss";
import vuetify from "./plugins/vuetify";
import resizeObserverHandler from "./utils/resizeObserverHandler";
import TextDateInput from "./components/TextDateInput.vue";
const app = createApp(App);
app.use(router);
app.use(createPinia());
app.use(vuetify);
app.component("TextDateInput", TextDateInput);
// Handle ResizeObserver warnings
resizeObserverHandler();
app.mount("#app");
